import * as React from "react";

export function ProblemStatusIcon() {
    return (
        <svg
            viewBox="-20 -20 40 40"
            width="31"
            height="31"
            aria-hidden="true"
            focusable="false"
            style={{ overflow: "visible" }}
        >
            <defs>
                <radialGradient id="bottomRightCheckGlow" cx="48%" cy="30%" r="72%">
                    <stop offset="0%" stopColor="#e9ff7a" stopOpacity="0.95" />
                    <stop offset="43%" stopColor="#98c72d" stopOpacity="0.58" />
                    <stop offset="100%" stopColor="#263707" stopOpacity="1" />
                </radialGradient>
                <linearGradient
                    id="bottomRightCheckFace"
                    x1="0"
                    y1="-14"
                    x2="0"
                    y2="14"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#dffb6a" />
                    <stop offset="35%" stopColor="#a9d92d" />
                    <stop offset="100%" stopColor="#4d6f0d" />
                </linearGradient>
            </defs>
            <g filter="drop-shadow(0 1px 2px rgba(0, 0, 0, 0.72)) drop-shadow(0 0 7px rgba(174, 228, 44, 0.28))">
                <circle
                    cx="0"
                    cy="0"
                    r="12.4"
                    fill="#0b1105"
                    stroke="#33480a"
                    strokeWidth="2.2"
                />
                <circle
                    cx="0"
                    cy="0"
                    r="11.2"
                    fill="none"
                    stroke="rgba(222, 255, 102, 0.58)"
                    strokeWidth="1"
                />
                <circle
                    cx="0"
                    cy="0"
                    r="9.7"
                    fill="url(#bottomRightCheckGlow)"
                    stroke="rgba(0, 0, 0, 0.34)"
                    strokeWidth="0.8"
                />
                <circle cx="-11.6" cy="0" r="1.1" fill="#d9f96a" opacity="0.5" />
                <circle cx="11.6" cy="0" r="1.1" fill="#d9f96a" opacity="0.5" />
                <path
                    d="M -5.6 0.2 L -1.6 4.2 L 6.7 -4.1"
                    fill="none"
                    stroke="rgba(33, 52, 3, 0.9)"
                    strokeWidth="5.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M -5.6 0.2 L -1.6 4.2 L 6.7 -4.1"
                    fill="none"
                    stroke="url(#bottomRightCheckFace)"
                    strokeWidth="3.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M -5.3 -0.3 L -1.8 3.2 L 5.9 -4.0"
                    fill="none"
                    stroke="rgba(255,255,255,0.5)"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}

export function QuickJournalArrowIcon() {
    return (
        <svg
            viewBox="-18 -18 36 36"
            width="34"
            height="34"
            aria-hidden="true"
            focusable="false"
            style={{ overflow: "visible" }}
        >
            <defs>
                <linearGradient
                    id="bottomRightArrowMetal"
                    x1="0"
                    y1="-14"
                    x2="0"
                    y2="14"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#ffe7a3" />
                    <stop offset="18%" stopColor="#f0c85e" />
                    <stop offset="50%" stopColor="#b8860b" />
                    <stop offset="100%" stopColor="#704a12" />
                </linearGradient>
                <linearGradient
                    id="bottomRightArrowHighlight"
                    x1="0"
                    y1="-14"
                    x2="0"
                    y2="8"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#fff5d1" stopOpacity="0.92" />
                    <stop offset="45%" stopColor="#ffe29b" stopOpacity="0.28" />
                    <stop offset="100%" stopColor="#ffe29b" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="bottomRightArrowSideShade"
                    x1="-9"
                    y1="-13"
                    x2="4"
                    y2="15"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#8f5f16" stopOpacity="0.62" />
                    <stop offset="60%" stopColor="#4f2f09" stopOpacity="0.82" />
                    <stop offset="100%" stopColor="#241404" stopOpacity="0.92" />
                </linearGradient>
            </defs>
            <g filter="drop-shadow(0 3px 2px rgba(14, 8, 3, 0.72)) drop-shadow(0 0 5px rgba(255, 211, 114, 0.18))">
                <path
                    d="M 1.5 -13.8 L 9.5 -1.1 L 4.5 -0.2 L 4.1 12.2 L 0 16 L -4.1 12.2 L -4.5 -0.2 L -9.5 -1.1 L -1.5 -13.8 Z"
                    fill="rgba(30, 16, 5, 0.9)"
                    transform="translate(0.9 1.2)"
                />
                <path
                    d="M 0 -15 L 9.2 -1.8 L 4 -0.5 L 3.6 11.6 L 0 15 L -3.6 11.6 L -4 -0.5 L -9.2 -1.8 Z"
                    fill="url(#bottomRightArrowMetal)"
                    stroke="rgba(48, 29, 6, 0.92)"
                    strokeWidth="1.25"
                    strokeLinejoin="round"
                />
                <path
                    d="M 0 -14 L -7.4 -2.1 L -3.4 -1.2 L -3.1 10.9 L 0 14.1 Z"
                    fill="url(#bottomRightArrowSideShade)"
                    opacity="0.74"
                />
                <path
                    d="M 0 -14 L 7.4 -2.1 L 3.4 -1.2 L 3.1 10.9 L 0 14.1 Z"
                    fill="rgba(255, 226, 139, 0.18)"
                />
                <path
                    d="M 0 -14 L 0 14.2"
                    stroke="rgba(255, 237, 174, 0.66)"
                    strokeWidth="0.95"
                    strokeLinecap="round"
                />
                <path
                    d="M 0 -13.6 L 6.2 -2.8 L 2 -2 L 1.8 10.2 L 0 12.4 Z"
                    fill="rgba(255, 232, 151, 0.22)"
                />
                <path
                    d="M -6.6 -1.2 L 0 -12.8 L 6.6 -1.2"
                    fill="none"
                    stroke="url(#bottomRightArrowHighlight)"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.82"
                />
            </g>
        </svg>
    );
}
